import Vue from "vue"

const state = {
  /**
   * Reserved state for SetUi
   */
  ui: {}
}

const getters = {
  getUi (state) {
    return state.ui
  }
}

const mutations = {
  /**
   * Set new state space, it can
   * be anything. If space already exist
   * changes will mutate it.
   * Use on: created hook
   */
  SET_SPACE (state, { namespace, data }) {
    if (state[namespace] === undefined) {
      Vue.set(state, namespace, data)
    }
    // Ensure that array gets cleared
    if (Array.isArray(data)) {
      Vue.set(state, namespace, data)
      return
    }
    // This is probably object or string
    // just keep on adding
    for (let key in data) {
      Vue.set(state[namespace], key, data[key])
    }
  },
  /**
   * Clear space
   * This is important so we don't hold
   * data - that we don't need.
   *
   * Clear space on the same component as
   * you have created it.
   * Use on: beforeDestroy hook
   */
  REMOVE_SPACE (state, spaces) {
    if (typeof spaces === "string") {
      delete state[spaces]
      return
    }
    for (let key in spaces) {
      delete state[spaces[key]]
    }
  },
  /**
   * SetUi is used to place flags into
   * the store. It allows you to make changes
   * and use it anywhere in your app - as long as
   * you have acess to this store
   *
   * Use: $setUi({ someFlag: "someValue" })
   */
  SET_UI (state, obj) {
    for (let key in obj) {
      Vue.set(state.ui, key, obj[key])
    }
  },
  /**
   * Clear UI keeps your flags clean
   * clear flags on the same place you have
   * set them.
   *
   * Use: $setUi({ someFlag: "someValue" })
   */
  REMOVE_UI (state, obj) {
    for (let key in obj) {
      delete state.ui[obj[key]]
    }
  }
}

const actions = {
  setSpace ({ commit }, [space, obj]) {
    commit("SET_SPACE", { namespace: space, data: obj })
  },
  removeSpace ({ commit }, spaces) {
    commit("REMOVE_SPACE", spaces)
  },
  setUi ({ commit }, obj) {
    commit("SET_UI", obj)
  },
  removeUi ({ commit }, obj) {
    commit("REMOVE_UI", obj)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
